import React, { useContext, useRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import SelectBox from '../../../components/SelectBox';

import '../../../index.css';

function SelectShop({ onSelectShop }) {
  const shopSelectBoxRef = useRef(null);

  const [selectedShop, setSelectedShop] = useState('');

  const [makeShopData, setMakeShopData] = useState({
    url: '',
    shopKey: '',
  });

  return (
    <InputContainer>
      <SubTitle>연동할 쇼핑몰을 선택해 주세요.</SubTitle>
      <FlexContainer>
        <SelectBox
          ref={shopSelectBoxRef}
          width={470}
          options={['카페24', '메이크샵']}
          onSelect={onSelectShop}
          defaultOption={selectedShop}
        />
        {selectedShop && (
          <ModifyButton
            onClick={() => {
              shopSelectBoxRef.current.handleOpen();
            }}
          >
            수정
          </ModifyButton>
        )}
      </FlexContainer>
    </InputContainer>
  );
}

export default SelectShop;

const InputContainer = styled.div`
  margin-bottom: 42px;
`;

const FlexContainer = styled.div`
  display: flex;
  align-items: center;
`;

const SubTitle = styled.p`
  font-size: 18px;
  margin-top: 42px;
  margin-bottom: 18px;
`;

const ModifyButton = styled.button`
  font-size: 14px;
  cursor: pointer;
  color: #b5b5b5;
  border: none;
  background-color: transparent;
  text-decoration: underline;
  text-underline-position: under;
  margin-left: 14px;
`;
